import React, { memo } from 'react';
import { ProductViewModel } from '~/lib/data-contract';
import { Accordion, AccordionItem, RawHtml } from '~/shared/components';

export type Props = Pick<ProductViewModel, 'accordions'>;

export const AccordionInfo = memo(({ accordions }: Props) => {
    return (
        <Accordion>
            {accordions?.map(({ title, value }, index) => (
                <AccordionItem
                    id={`PDP-${index.toString()}`}
                    header={title}
                    initAsOpen={index === 0}
                    key={index}
                >
                    <RawHtml html={value} />
                </AccordionItem>
            ))}
        </Accordion>
    );
});
